import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface Payload {
  messageText: string;
}

interface Query {
  expand: string;
}

export default (makeCall: MakeCall) =>
  (conversationId: number, data: Payload, query?: Query) =>
    makeCall<Conversation>(
      'PUT',
      `/api/v2/conversation/${conversationId}/response`,
      { data, query },
    );
